// 将用户id转换为桐学号
export function getShortMemberId(memberId: string): string {
  if (memberId === '0') return '0'

  let remainingVal = memberId
  const shift = 5 // 32=2^5
  const buf: string[] = []
  const digits = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'J',
    'K',
    'M',
    'N',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'V',
    'W',
    'X',
    'Y',
    'Z'
  ]

  // 步骤1：把超大数字符串拆分为高32位和低32位（Number类型，32位内无精度丢失）
  const [high32, low32] = split64BitStrToHighLow(remainingVal)
  let h = high32
  let l = low32

  // 步骤2：模拟64位无符号右移和取模运算
  do {
    // 模拟 (h << 32 | l) & 31 → 取64位数的最后5位
    const last5Bits = l & 31
    buf.push(digits[last5Bits])

    // 模拟64位无符号右移5位（核心逻辑）
    // 1. 低32位右移5位，高位补高32位的最后5位
    const hLast5Bits = h & ((1 << shift) - 1) // 取高32位最后5位
    const lShifted = (l >>> shift) | (hLast5Bits << (32 - shift))
    // 2. 高32位右移5位
    const hShifted = h >>> shift
    // 更新高/低32位
    h = hShifted
    l = lShifted
  } while (h !== 0 || l !== 0)

  // 反转得到正确顺序（因为是从低位到高位存储）
  return buf.reverse().join('')
}

function split64BitStrToHighLow(numStr: string) {
  const TWO_POW_32 = Math.pow(2, 32)
  // 方法：通过字符串逐位除法，计算 num / 2^32（高32位）和 num % 2^32（低32位）
  let high = 0
  let low = 0

  for (let i = 0; i < numStr.length; i++) {
    const digit = parseInt(numStr[i])
    // 分步计算：(当前值 * 10 + 新位)，避免溢出
    // 先算高32位：high = high * 10 + Math.floor((low * 10 + digit) / TWO_POW_32)
    const tempLow = low * 10 + digit
    high = high * 10 + Math.floor(tempLow / TWO_POW_32)
    // 再算低32位：low = tempLow % TWO_POW_32
    low = tempLow % TWO_POW_32
  }

  return [high, low]
}
